module.exports = __webpack_public_path__ + "img/hematologico.c90558b1.png";